module.exports = __webpack_public_path__ + "static/media/hugging-faces.75e8d015.png";